import React from "react";
import { motion } from "framer-motion";
import { Award, BadgeCheck, HeartPulse, MapPin, Sparkles } from "lucide-react";
import Footer from "./Footer";

const expertise = [
  "Hatha Yoga",
  "Power Yoga",
  "Therapeutic Yoga",
  "Stress Management Yoga",
  "Breathing and Meditation Techniques",
];

const branches = [
  {
    title: "Sanganer",
    text: "A peaceful studio environment for consistent yoga practice in the heart of Sanganer.",
  },
  {
    title: "Mansarovar",
    text: "Expert-led classes focused on strength, flexibility, breathing, and relaxation.",
  },
];

const About = () => {
  return (
    <main className="ym-page">
      <section className="ym-section">
        <div className="ym-container ym-split">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55 }}>
            <span className="ym-eyebrow">
              <Sparkles size={14} />
              About YogaMatic
            </span>
            <h1 className="ym-title">Guided practice with a human touch.</h1>
            <p className="ym-lead">
              YogaMatic helps students build strength, flexibility, breath awareness, and mental calm through thoughtful
              instruction and simple class booking.
            </p>
          </motion.div>

          <motion.div
            className="ym-card ym-glass"
            style={{ padding: 18 }}
            initial={{ opacity: 0, x: 28 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.55 }}
          >
            <img
              src="/WhatsApp Image 2025-03-15 at 8.46.52 PM.jpeg"
              alt="Ajay Nama"
              style={{ width: "100%", height: 420, objectFit: "cover", borderRadius: "var(--ym-radius)" }}
            />
          </motion.div>
        </div>
      </section>

      <section className="ym-section ym-section-band">
        <div className="ym-container ym-split">
          <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <span className="ym-eyebrow">
              <HeartPulse size={14} />
              Founder and instructor
            </span>
            <h2 className="ym-title-small">Ajay Nama</h2>
            <p className="ym-lead">
              Certified Yoga Instructor and Therapy Expert trained in Bangalore, with experience across Hatha Yoga,
              Power Yoga, and Therapeutic Yoga.
            </p>
            <p className="ym-text" style={{ marginTop: 18 }}>
              His approach focuses on practical wellness: back pain therapy, stress relief, breathing techniques,
              flexibility, posture, and personalized guidance.
            </p>
          </motion.div>

          <div className="ym-grid-2">
            {expertise.map((item, index) => (
              <motion.div
                className="ym-card ym-card-pad"
                key={item}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
              >
                <span className="ym-icon-box">
                  <Award size={20} />
                </span>
                <h3 style={{ margin: "14px 0 0", fontSize: 18, fontWeight: 850 }}>{item}</h3>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="ym-section">
        <div className="ym-container">
          <div style={{ textAlign: "center", marginBottom: 30 }}>
            <span className="ym-eyebrow" style={{ marginInline: "auto" }}>
              <MapPin size={14} />
              Studio locations
            </span>
            <h2 className="ym-title-small">Practice near you.</h2>
          </div>

          <div className="ym-grid-2">
            {branches.map((branch, index) => (
              <motion.article
                className="ym-card ym-card-pad"
                key={branch.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                whileHover={{ y: -5 }}
              >
                <span className="ym-icon-box">
                  <BadgeCheck size={20} />
                </span>
                <h3 style={{ margin: "16px 0 8px", fontSize: 24, fontWeight: 850 }}>Branch: {branch.title}</h3>
                <p className="ym-text">{branch.text}</p>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default About;
